import { render, staticRenderFns } from "./Subs.vue?vue&type=template&id=68265030&scoped=true&"
import script from "./Subs.vue?vue&type=script&lang=js&"
export * from "./Subs.vue?vue&type=script&lang=js&"
import style0 from "./Subs.vue?vue&type=style&index=0&id=68265030&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68265030",
  null
  
)

export default component.exports